import script from "./invoice-djsj-add-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-djsj-add-dialog.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__